import type { NuxtError } from '#app'
import { createError, defineNuxtRouteMiddleware, navigateTo } from '#imports'
import { ref } from 'vue'

import { MODELS_COMPARISON } from '~/scopes/models-comparison/routes-names'

import type {
  ErrorData,
  RedirectErrorDetails,
} from '../../composables/useEnrichResultsPage/useEnrichResultsPage.types'
import { useFetchResultsPage } from '../../composables/useFetchResultsPage/useFetchResultsPage'

function handleComparisonError(error: NuxtError<ErrorData>) {
  const errorDetails = error.data?.errors?.[0]?.context?.payload?.detail?.error
    ?.details as RedirectErrorDetails | undefined

  if (
    errorDetails?.error_type === 'redirect_to' &&
    errorDetails.slug_1 &&
    errorDetails.slug_2
  ) {
    return navigateTo(
      {
        name: MODELS_COMPARISON.RESULTS,
        params: {
          productA: errorDetails.slug_1,
          productB: errorDetails.slug_2,
        },
      },
      { redirectCode: 301 },
    )
  }

  throw createError({
    statusCode: error.statusCode ?? 404,
    fatal: true,
  })
}

export default defineNuxtRouteMiddleware(async function compareRedirect(to) {
  if (to.name !== MODELS_COMPARISON.RESULTS) return undefined

  const { error } = await useFetchResultsPage(
    ref(String(to.params.productA)),
    ref(String(to.params.productB)),
  )

  return error.value ? handleComparisonError(error.value) : undefined
})
